export function base64ToFile(base64: string, filename: string): File {
  const [meta, content] = base64.split(",");
  const mimeMatch = meta.match(/:(.*?);/);
  if (!mimeMatch) {
    throw new Error("MIMETYPE not found in base64 string.");
  }
  const mimeType = mimeMatch[1];

  const byteCharacters = atob(content);
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: mimeType });
  return new File([blob], filename, { type: mimeType });
}
